import type { BlockComponentProps } from "./registry";

export function PlaceholderBlock({ node }: BlockComponentProps) {
  const type = String(node.data.get("type"));
  return <div className="rounded border border-dashed border-neutral-300 p-3 text-sm text-neutral-500">{type} block (editor arrives in M2/M5)</div>;
}
